const AnkerslogenLongDE = ({ isMobile, ...props }: { isMobile: boolean }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 402 23"
    >
      <defs>
        <style>{`
          .cls-1, .cls-2, .cls-3 {
            stroke-width: 0;
          }
    
          .cls-1, .cls-3 {
            fill: #00befa;
          }
    
          .cls-2 {
            fill: #00befa;
          }
    
          .cls-2, .cls-3 {
            fill-rule: evenodd;
          }
        `}</style>
      </defs>
      <path
        className="cls-3"
        d="M73.7,8.7c0,1.2-.8,1.9-2.1,1.9h-4.3v-3.7h4.3c1.6,0,2.1,1.1,2.1,1.8ZM73.9,13.3c1.8-1.4,2.6-2.8,2.5-4.7-.2-2.7-2.4-4.5-4.9-4.5h-7.1v15.6h2.8v-6.4h3.3l4,6.4h3.3l-4-6.4h0Z"
      />
      <path
        className="cls-3"
        d="M42.8,13.9l3.7,5.8h3.4s-5.2-8.3-5.2-8.3l-1.8,2.4Z"
      />
      <path
        className="cls-3"
        d="M48.8,4.1h-3.6l-7.4,9.9V4.1h-2.8v14.2c0,.5.3,1.2,1.1,1.4.3,0,1,0,1.4-.5,0,0,11.4-15.1,11.4-15.1Z"
      />
      <path className="cls-1" d="M60.7,10.6h-5.6v2.8h5.6v-2.8Z" />
      <path
        className="cls-3"
        d="M62.2,4.1h-11.1v14.2c0,.8.6,1.4,1.4,1.4h9.7v-2.8h-8.3V6.9h8.3v-2.8Z"
      />
      <path
        className="cls-3"
        d="M29.9,4.1v9.9l-7.4-9.9h-3.6v15.6h2.8V7.9c3.4,4.4,8.5,11.3,8.6,11.3.4.5,1,.6,1.4.5.8-.2,1.1-.8,1.1-1.4V4.1h-2.8,0Z"
      />
      <path
        className="cls-3"
        d="M7.3,5L0,19.7h3.2l5.5-11.1,5.5,11.1h3.1l-7.2-14.7c-.3-.5-.8-.9-1.4-.9s-1.1.3-1.4.8Z"
      />
      <path
        className="cls-3"
        d="M11.2,17.5h-1.9s0,0,0,0l.4-4s0,0,0,0l-4,5.3s0,0,0,0h1.9s0,0,0,0l-.4,4s0,0,0,0l4-5.3s0,0,0,0"
      />
      <path className="cls-2" d="M87.8,20V4h.8v16h-.8Z" />
      <path
        className="cls-1"
        d="M401.4,13.1l-1,.8-1.1-1.4-1.1,1.4-1-.8,1.1-1.3-1.5-.5.4-1.2,1.5.5v-1.6h1.3v1.6l1.5-.5.5,1.2-1.6.5,1,1.3Z"
      />
      <path
        className="cls-1"
        d="M392,11.4c.6,0,1.2.2,1.7.5.5.3.9.7,1.1,1.3.3.5.4,1.1.4,1.8v5.1h-1.7v-4.7c0-.8-.2-1.3-.5-1.7-.3-.4-.8-.6-1.4-.6s-1.2.2-1.6.7c-.4.5-.6,1.1-.6,1.8v4.5h-1.7v-8.4h1.2l.3,1.2c.3-.4.7-.8,1.2-1,.5-.2,1.1-.4,1.7-.4Z"
      />
      <path
        className="cls-1"
        d="M385.9,15.8c0,.1,0,.3,0,.6h-6.8c.1.7.4,1.2.8,1.6.5.4,1,.6,1.7.6s.9-.1,1.3-.3c.4-.2.7-.5.9-.9h1.8c-.3.9-.9,1.6-1.6,2.1s-1.6.8-2.5.8-1.6-.2-2.2-.6c-.7-.4-1.2-.9-1.6-1.6-.4-.7-.6-1.4-.6-2.3s.2-1.6.6-2.3c.4-.7.9-1.2,1.6-1.6.7-.4,1.4-.6,2.2-.6s1.6.2,2.2.6c.7.4,1.2.9,1.5,1.6.4.7.5,1.4.5,2.2ZM381.6,12.9c-.7,0-1.2.2-1.7.5-.4.4-.7.9-.9,1.5h5.1c-.2-.6-.5-1.1-.9-1.5-.4-.4-1-.5-1.6-.5Z"
      />
      <path
        className="cls-1"
        d="M375.5,20h-1.3l-.2-1c-.4.4-.8.7-1.3.9-.5.2-1.1.3-1.6.3-.8,0-1.6-.2-2.3-.6-.7-.4-1.2-.9-1.6-1.6-.4-.7-.6-1.4-.6-2.3s.2-1.6.6-2.3c.4-.7.9-1.2,1.6-1.6.7-.4,1.4-.6,2.3-.6s1,0,1.5.3c.5.2.9.4,1.3.7v-3.8h1.7v11.5ZM371.2,18.5c.5,0,1-.1,1.4-.4.4-.2.8-.6,1-1,.2-.4.4-.9.4-1.4s-.1-1-.4-1.4c-.2-.4-.6-.8-1-1-.4-.2-.9-.4-1.4-.4s-1,.1-1.4.4c-.4.2-.7.6-1,1-.2.4-.3.9-.3,1.4s.1,1,.3,1.4c.2.4.6.7,1,1,.4.2.9.4,1.4.4Z"
      />
      <path
        className="cls-1"
        d="M364.9,20h-1.4l-.2-1c-.4.4-.8.7-1.4.9-.5.2-1.1.3-1.7.3s-1.6-.2-2.2-.6c-.7-.4-1.2-.9-1.6-1.6-.4-.7-.6-1.4-.6-2.3s.2-1.6.6-2.3c.4-.7.9-1.2,1.6-1.6.7-.4,1.4-.6,2.2-.6s1.2.1,1.7.3c.5.2,1,.5,1.4.9l.2-1h1.3v8.4ZM360.4,18.5c.5,0,1-.1,1.4-.4.4-.2.8-.6,1-1,.2-.4.4-.9.4-1.4s-.1-1-.4-1.4c-.2-.4-.6-.8-1-1-.4-.2-.9-.4-1.4-.4s-1,.1-1.4.4c-.4.2-.7.6-1,1-.2.4-.4.9-.4,1.4s.1,1,.4,1.4c.2.4.6.7,1,1,.4.2.9.4,1.4.4Z"
      />
      <path className="cls-1" d="M355.4,20h-6.3v-10.9h1.8v9.3h4.5v1.7Z" />
      <path
        className="cls-1"
        d="M340,20.2c-1,0-1.9-.3-2.5-.8-.6-.5-.9-1.2-1-2.1h1.7c0,.4.2.8.5,1,.3.2.8.3,1.3.3s.9,0,1.2-.3c.3-.2.5-.5.5-.8s-.2-.6-.5-.8-.8-.3-1.5-.4c-.6-.1-1.1-.2-1.6-.4-.4-.1-.8-.4-1.1-.7-.3-.3-.4-.8-.4-1.4s.1-.9.4-1.3c.3-.4.7-.7,1.1-.9.5-.2,1.1-.3,1.7-.3,1,0,1.8.2,2.3.7.6.5.9,1.1.9,2h-1.6c0-.4-.2-.7-.5-.9-.3-.2-.7-.3-1.2-.3s-.9,0-1.1.3c-.3.2-.4.4-.4.7s.2.6.5.7c.3.1.8.2,1.4.3.7.1,1.2.2,1.6.4.4.1.8.4,1.1.7.3.3.5.8.5,1.5s-.3,1.5-.9,2c-.6.5-1.5.7-2.5.7Z"
      />
      <path
        className="cls-1"
        d="M335.5,15.8c0,.1,0,.3,0,.6h-6.8c.1.7.4,1.2.8,1.6.5.4,1,.6,1.7.6s.9-.1,1.3-.3c.4-.2.7-.5.9-.9h1.8c-.3.9-.9,1.6-1.6,2.1-.7.5-1.6.8-2.5.8s-1.6-.2-2.2-.6c-.7-.4-1.2-.9-1.6-1.6-.4-.7-.6-1.4-.6-2.3s.2-1.6.6-2.3c.4-.7.9-1.2,1.6-1.6.7-.4,1.4-.6,2.2-.6s1.6.2,2.2.6c.7.4,1.2.9,1.5,1.6.4.7.5,1.4.5,2.2ZM331.2,12.9c-.7,0-1.2.2-1.7.5-.4.4-.7.9-.9,1.5h5.1c-.2-.6-.5-1.1-.9-1.5-.4-.4-1-.5-1.6-.5Z"
      />
      <path className="cls-1" d="M325.2,8.5v11.5h-1.7v-11.5h1.7Z" />
      <path
        className="cls-1"
        d="M321.2,8.5v1.8h-1.8v-1.8h1.8ZM321.1,11.6v8.4h-1.7v-8.4h1.7Z"
      />
      <path
        className="cls-1"
        d="M313.3,11.4c.8,0,1.6.2,2.3.6.7.4,1.2.9,1.6,1.6.4.7.6,1.4.6,2.3s-.2,1.6-.6,2.3c-.4.7-.9,1.2-1.6,1.6-.7.4-1.4.6-2.3.6s-1.1,0-1.6-.3c-.5-.2-.9-.5-1.3-.9l-.2,1h-1.3v-11.5h1.7v3.8c.4-.3.8-.6,1.3-.7.5-.2,1-.3,1.5-.3ZM313.2,18.5c.5,0,1-.1,1.4-.4.4-.2.8-.6,1-1,.2-.4.4-.9.4-1.4s-.1-1-.4-1.4c-.2-.4-.6-.8-1-1-.4-.2-.9-.4-1.4-.4s-1,.1-1.4.4c-.4.2-.7.6-1,1-.2.4-.4.9-.4,1.4s.1,1,.4,1.4c.2.4.6.8,1,1,.4.2.9.4,1.4.4Z"
      />
      <path
        className="cls-1"
        d="M302.6,20.2c-.8,0-1.6-.2-2.3-.6-.7-.4-1.2-.9-1.6-1.6-.4-.7-.6-1.4-.6-2.3s.2-1.6.6-2.3c.4-.7.9-1.2,1.6-1.6.7-.4,1.5-.6,2.3-.6s1.6.2,2.3.6c.7.4,1.2.9,1.6,1.6.4.7.6,1.4.6,2.3s-.2,1.6-.6,2.3c-.4.7-.9,1.2-1.6,1.6-.7.4-1.5.6-2.3.6ZM302.6,18.5c.5,0,1-.1,1.4-.3.4-.2.8-.6,1-1,.2-.4.4-.9.4-1.4s-.1-1-.4-1.4c-.2-.4-.6-.8-1-1-.4-.2-.9-.4-1.4-.4s-1,.1-1.4.4c-.4.2-.7.6-1,1-.2.4-.3.9-.3,1.4s.1,1,.3,1.4c.2.4.6.7,1,1,.4.2.9.3,1.4.3Z"
      />
      <path
        className="cls-1"
        d="M293.5,11.4c.6,0,1.1.1,1.5.4.5.3.8.7,1.1,1.2.2.5.4,1.1.4,1.7v5.4h-1.7v-4.9c0-.7-.1-1.2-.4-1.6-.3-.4-.7-.6-1.2-.6s-.7.1-1,.3c-.3.2-.5.5-.7.9-.2.4-.2.8-.2,1.3v4.6h-1.7v-4.9c0-.7-.1-1.2-.4-1.6-.3-.4-.7-.6-1.2-.6s-.7.1-1,.3c-.3.2-.5.5-.7.9-.2.4-.2.8-.2,1.3v4.6h-1.7v-8.4h1.2l.3,1.1c.3-.4.7-.7,1.2-.9.5-.2,1-.3,1.5-.3s1.1.1,1.5.4c.4.3.8.6,1,1.1.3-.5.7-.8,1.2-1.1.5-.3,1-.4,1.6-.4Z"
      />
      <path
        className="cls-1"
        d="M279.5,13.2h-.9c-.7,0-1.3.2-1.6.6-.4.4-.5,1-.5,1.8v4.5h-1.7v-8.4h1.2l.3,1.2c.3-.4.7-.7,1.1-.9.4-.2.9-.3,1.5-.3h.8v1.6Z"
      />
      <path
        className="cls-1"
        d="M268,8.5v1.8h-1.9v-1.8h1.9ZM271.3,8.5v1.8h-1.9v-1.8h1.9ZM268.7,20.2c-.8,0-1.4-.2-2-.5-.6-.3-1-.8-1.3-1.3-.3-.6-.5-1.2-.5-2v-4.9h1.7v4.6c0,.7.2,1.3.6,1.7.4.4.9.6,1.5.6s1.2-.2,1.5-.6c.4-.4.6-1,.6-1.7v-4.6h1.7v4.9c0,.8-.2,1.4-.5,2-.3.6-.8,1-1.3,1.3-.6.3-1.2.5-2,.5Z"
      />
      <path
        className="cls-1"
        d="M261.3,13.1v6.9h-1.7v-6.9h-1.6v-1.4h1.6v-.7c0-.9.2-1.5.7-2,.4-.5,1.1-.7,2-.7h1.4v1.4h-1.1c-.5,0-.8.1-1,.3-.2.2-.3.5-.3,1v.7h2.4v1.4h-2.4Z"
      />
      <path
        className="cls-1"
        d="M246.7,1.4h7.6l-3.7,18.6h-4.9l2.9-14.5h-2.7l.8-4Z"
      />
      <path className="cls-1" d="M230.2,20l.9-4.8h4.9l-.9,4.8h-4.9Z" />
      <path
        className="cls-1"
        d="M231.5,4.9h1.5l-.9,4.6h-2c-1.9,0-2.8.8-3.2,2.6l-1.6,7.9h-5l3-15.1h3.3l.4,1.6c1.3-1.1,2.7-1.6,4.5-1.6Z"
      />
      <path
        className="cls-1"
        d="M215.9.5h5.1l-3.9,19.5h-4.3l-5.7-11-2.2,11h-5.1l3.9-19.5h4.5l5.5,10.8,2.2-10.8Z"
      />
      <path
        className="cls-1"
        d="M195.1,15.8c0,.1,0,.3,0,.6h-6.8c.1.7.4,1.2.8,1.6.5.4,1,.6,1.7.6s.9-.1,1.3-.3c.4-.2.7-.5.9-.9h1.8c-.3.9-.9,1.6-1.6,2.1-.7.5-1.6.8-2.5.8s-1.6-.2-2.2-.6c-.7-.4-1.2-.9-1.6-1.6-.4-.7-.6-1.4-.6-2.3s.2-1.6.6-2.3c.4-.7.9-1.2,1.6-1.6.7-.4,1.4-.6,2.2-.6s1.6.2,2.2.6c.7.4,1.2.9,1.5,1.6.4.7.5,1.4.5,2.2ZM190.8,12.9c-.7,0-1.2.2-1.7.5-.4.4-.7.9-.9,1.5h5.1c-.2-.6-.5-1.1-.9-1.5-.4-.4-1-.5-1.6-.5Z"
      />
      <path
        className="cls-1"
        d="M184.8,8.5v1.8h-1.8v-1.8h1.8ZM184.7,11.6v8.4h-1.7v-8.4h1.7Z"
      />
      <path
        className="cls-1"
        d="M180.7,20h-1.3l-.2-1c-.4.4-.8.7-1.3.9-.5.2-1.1.3-1.6.3-.8,0-1.6-.2-2.3-.6-.7-.4-1.2-.9-1.6-1.6-.4-.7-.6-1.4-.6-2.3s.2-1.6.6-2.3c.4-.7.9-1.2,1.6-1.6.7-.4,1.4-.6,2.3-.6s1,0,1.5.3c.5.2.9.4,1.3.7v-3.8h1.7v11.5ZM176.3,18.5c.5,0,1-.1,1.4-.4.4-.2.8-.6,1-1,.2-.4.4-.9.4-1.4s-.1-1-.4-1.4c-.2-.4-.6-.8-1-1-.4-.2-.9-.4-1.4-.4s-1,.1-1.4.4c-.4.2-.7.6-1,1-.2.4-.3.9-.3,1.4s.1,1,.3,1.4c.2.4.6.7,1,1,.4.2.9.4,1.4.4Z"
      />
      <path
        className="cls-1"
        d="M167.1,20h-1.3c-.9,0-1.7-.3-2.2-.8-.5-.5-.8-1.3-.8-2.2v-4h-1.5v-.3l2.9-3.1h.3v2h2.5v1.5h-2.5v3.8c0,.5.1.9.4,1.2.3.3.7.4,1.2.4h1v1.6Z"
      />
      <path
        className="cls-1"
        d="M160.1,8.5v1.8h-1.8v-1.8h1.8ZM160.1,11.6v8.4h-1.7v-8.4h1.7Z"
      />
      <path
        className="cls-1"
        d="M156.6,15.8c0,.1,0,.3,0,.6h-6.8c.1.7.4,1.2.8,1.6.5.4,1,.6,1.7.6s.9-.1,1.3-.3c.4-.2.7-.5.9-.9h1.8c-.3.9-.9,1.6-1.6,2.1-.7.5-1.6.8-2.5.8s-1.6-.2-2.2-.6c-.7-.4-1.2-.9-1.6-1.6-.4-.7-.6-1.4-.6-2.3s.2-1.6.6-2.3c.4-.7.9-1.2,1.6-1.6.7-.4,1.4-.6,2.2-.6s1.6.2,2.2.6c.7.4,1.2.9,1.5,1.6.4.7.5,1.4.5,2.2ZM152.3,12.9c-.7,0-1.2.2-1.7.5-.4.4-.7.9-.9,1.5h5.1c-.2-.6-.5-1.1-.9-1.5-.4-.4-1-.5-1.6-.5Z"
      />
      <path
        className="cls-1"
        d="M144.6,20h-1.4l-2.2-5.1-2.2,5.1h-1.4l-2.8-8.4h1.8l1.9,5.7,2.4-5.6h.6l2.5,5.6,1.9-5.7h1.7l-2.8,8.4Z"
      />
      <path
        className="cls-1"
        d="M134.1,20h-1.3c-.9,0-1.7-.3-2.2-.8-.5-.5-.8-1.3-.8-2.2v-4h-1.5v-.3l2.9-3.1h.3v2h2.5v1.5h-2.5v3.8c0,.5.1.9.4,1.2.3.3.7.4,1.2.4h1v1.6Z"
      />
      <path className="cls-1" d="M127.1,8.5v11.5h-1.7v-11.5h1.7Z" />
      <path
        className="cls-1"
        d="M123.7,15.8c0,.1,0,.3,0,.6h-6.8c.1.7.4,1.2.8,1.6.5.4,1,.6,1.7.6s.9-.1,1.3-.3c.4-.2.7-.5.9-.9h1.8c-.3.9-.9,1.6-1.6,2.1-.7.5-1.6.8-2.5.8s-1.6-.2-2.2-.6c-.7-.4-1.2-.9-1.6-1.6-.4-.7-.6-1.4-.6-2.3s.2-1.6.6-2.3c.4-.7.9-1.2,1.6-1.6.7-.4,1.4-.6,2.2-.6s1.6.2,2.2.6c.7.4,1.2.9,1.5,1.6.4.7.5,1.4.5,2.2ZM119.4,12.9c-.7,0-1.2.2-1.7.5-.4.4-.7.9-.9,1.5h5.1c-.2-.6-.5-1.1-.9-1.5-.4-.4-1-.5-1.6-.5Z"
      />
      <path
        className="cls-1"
        d="M111.5,20h-1.6l-2.8-7.1-2.7,7.1h-1.6l-3.5-10.9h1.9l2.5,8.1,3.1-7.9h.7l3.1,7.9,2.4-8.1h1.9l-3.4,10.9Z"
      />
    </svg>
  )
}

export default AnkerslogenLongDE
